import React from "react";
import { Link } from "react-router-dom";
import "./HomeShowcase.css";
import teaImg from "../assets/HomePage/green.webp";
import coconutImg from "../assets/HomePage/coco2.webp";
import cinnamonImg from "../assets/HomePage/cino-new.webp";
import riceImg from "../assets/HomePage/rice.webp";

const collections = [
  { title: "Ceylon Tea", detail: "From the highlands, with character.", image: teaImg, path: "/tea", label: "01 / THE DAILY RITUAL" },
  { title: "Coconut", detail: "Island-grown. Endlessly versatile.", image: coconutImg, path: "/coconut", label: "02 / TROPICAL ESSENTIALS" },
  { title: "Ceylon Spices", detail: "A little warmth. A world of flavor.", image: cinnamonImg, path: "/spices", label: "03 / AROMATIC ORIGINS" },
  { title: "Traditional Rice", detail: "A taste of our agricultural heritage.", image: riceImg, path: "/rice", label: "04 / FROM OUR FIELDS" },
];

export default function HomeShowcase() {
  return (
    <section className="ceymos-collection" id="our-collection" aria-labelledby="collection-heading">
      <div className="ceymos-collection-heading"><div><p className="ceymos-eyebrow">The Ceymos collection</p><h2 id="collection-heading">Good things grow here.</h2></div><p>Four ways to experience the richness of Sri Lanka. Find something extraordinary in the everyday.</p></div>
      <div className="ceymos-collection-grid">{collections.map(item => (
        <Link className="ceymos-collection-card" to={item.path} key={item.path}>
          <div className="ceymos-collection-image"><span>{item.label}</span><img src={item.image} alt={item.title} loading="lazy" width="320" height="280" /></div>
          <div className="ceymos-collection-title"><h3>{item.title}</h3><span aria-hidden="true">↗</span></div><p>{item.detail}</p>
        </Link>
      ))}</div>
      <div className="ceymos-collection-note"><span>A connection from our island to your business.</span><Link to="/contact">Find your export partner <span aria-hidden="true">→</span></Link></div>
    </section>
  );
}
